import React from 'react';
import {Avatar, Box, Sheet, Stack} from '@mui/joy';
import Education from "./Education";
import {Circle} from "@mui/icons-material";
import {SkillModel} from "../model/skill";
import {EducationModel} from "../model/education";
import Service from "./Service";
function Educations({educations} :{educations: Array<EducationModel>}) {
    return (
        <Stack direction='row' sx={{justifyContent: 'space-around', alignItems: 'flex-start', borderRadius: 8,}}>
            <Box display={{xs: 'none', lg: 'block'}}>
                <Avatar  sx={{width:128, height:128}} size='sm' variant='soft' color='primary'>
                    <Circle sx={{fontSize:128}}/>
                </Avatar>
            </Box>
            <Sheet
                variant='soft'
                sx={{
                    paddingY: 2,
                    paddingX:2,
                    width: '100%',
                    maxWidth: 800,
                    borderRadius: 16,
                }}>
                <Stack width='100%' sx={{padding: 0}} justifyContent={{xs: 'start', md: 'space-between'}} direction={{xs: 'column', md: 'row'}}>
                    <Stack direction='column' spacing={2}>
                        {
                            educations.slice(0, Math.round(educations.length / 2)).map(value => (
                                <Education education = {value}/>
                            ))
                        }
                    </Stack>
                    <Stack paddingTop={{xs: 2, md: 0}} direction='column' spacing={2}>
                        {
                            educations.slice(Math.round(educations.length / 2) , educations.length).map(value => (
                                <Education education = {value}/>
                            ))
                        }
                    </Stack>
                </Stack>
            </Sheet>
        </Stack>
    );
}

export default Educations;